import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards, Navigation} from "swiper";
// import { EffectCards } from 'swiper/modules';

import img1 from "../../../static/images/carsubs/garage/garage1.jpg";
import img2 from "../../../static/images/carsubs/garage/garage2.jpg";
import img3 from "../../../static/images/carsubs/garage/garage3.jpg";
import img4 from "../../../static/images/carsubs/garage/garage4.jpg";
import img5 from "../../../static/images/carsubs/garage/garage5.jpg";
import img6 from "../../../static/images/carsubs/garage/garage6.jpg";
import img7 from "../../../static/images/carsubs/garage/garage7.jpg";
import img8 from "../../../static/images/carsubs/garage/garage8.jpg";
import img9 from "../../../static/images/carsubs/garage/garage9.jpg";
import img10 from "../../../static/images/carsubs/garage/garage10.jpg";

import banner from "../../../static/images/carsubs/garage/banner.png";


const LIST_ITEM = [
	{
		id: 1,
		img: img1,
	},
	{
		id: 2,
		img: img2,
	},
	{
		id: 3,
		img: img3,
	},
	{
		id: 4,
		img: img4,
	},
	{
		id: 5,
		img: img5,
	},
	{
		id: 6,
		img: img6,
	},
	{
		id: 7,
		img: img7,
	},
	{
		id: 8,
		img: img8,
	},
	{
		id: 9,
		img: img9,
	},
	{
		id: 10,
		img: img10,
	},
];

const Item = ({ item }) => (
	<div className="photo-item fix-img">
		<img loading="eager" src={item.img} />
	</div>
);

const PartnerGarage = () => {
	return (
		<div className="user-section">
			<div className="m-container">
			<div className="garage-banner" style={{backgroundImage: `url(${banner})`}}>
   			     <div className="garage-inner">
   			       <div className="content-banner"> 
						<h2>Hình Ảnh Garage Của Đối&nbsp;Tác</h2>
						<div className="wrap-svg">
							<svg xmlns="http://www.w3.org/2000/svg" width={240} height={4} viewBox="0 0 240 4" fill="none">
							<path d="M0 2.00049H240" stroke="white" strokeWidth={4} />
							</svg>
						</div>
					
						<p className="text">Chúng tôi lựa chọn các garage có thương hiệu và uy tín về dịch vụ bảo trì, bảo dưỡng, sửa chữa ô tô… Với dàn kỹ thuật viên tay nghề cao và nhiều kinh nghiệm, đảm bảo mang đến cho quý khách hàng sự an toàn, yên tâm tuyệt đối khi vận hành xe. Đội ngũ chúng tôi cam kết sẵn sàng hỗ trợ ngay khi khách hàng có yêu cầu.</p>
					</div>
				<Swiper
					className="swiper-card swiper-cards"
					// slidesPerView={1}
					modules={[EffectCards, Navigation]}
					effect="cards"
					navigation={{
						nextEl: '.card-next',
						prevEl: '.card-prev',
					}}
					grabCursor={true}
					// centeredSlides={true}
					// loop={true}
					>
					{LIST_ITEM.map((item) => (
						<SwiperSlide key={item.id}>
							<Item item={item} />
						</SwiperSlide>
					))}
					<div className="swiper-button-next card-next"></div>
					<div className="swiper-button-prev card-prev"></div>
				
				</Swiper>
			
			</div>
		</div>
		</div>
		</div>
	);
};

export default PartnerGarage;

	// <div className="user-section">
    //     <div className="m-container"> 
    //       <div className="garage-banner" style={{backgroundImage: 'url(images/carsubs/garage/banner.png)'}}>
    //         <div className="garage-inner">
    //           <div className="content-banner"> 
    //             <h2>
    //               Hình Ảnh Garage Của&nbsp;Đối&nbsp;Tác</h2>
    //           </div>
    //           <div className="swiper swiper-card swiper-cards swiper-3d swiper-initialized swiper-horizontal swiper-pointer-events swiper-watch-progress">
    //             <div className="swiper-wrapper" style={{cursor: 'grab'}} id="swiper-wrapper-61f2faf4c5f26370" aria-live="polite">
    //               <div className="swiper-slide swiper-slide-visible swiper-slide-active" style={{width: '360px', zIndex: 3, transform: 'translate3d(0px, 0px, 0px) rotateZ(0deg) scale(1)'}} role="group" aria-label="1 / 3"> <img src="images/carsubs/garage/garage2.jpg" alt="" /><div className="swiper-slide-shadow" style={{opacity: 0}} /></div>
    //               <div className="swiper-slide swiper-slide-next" style={{width: '360px', zIndex: 2, transform: 'translate3d(calc(7.25% - 360px), 0px, -100px) rotateZ(2deg) scale(1)'}} role="group" aria-label="2 / 3"> <img src="images/carsubs/garage/garage6.jpg" alt="" /><div className="swiper-slide-shadow" style={{opacity: 1}} /></div>
    //               <div className="swiper-slide" style={{width: '360px', zIndex: 1, transform: 'translate3d(calc(13% - 720px), 0px, -200px) rotateZ(4deg) scale(1)'}} role="group" aria-label="3 / 3"> <img src="images/carsubs/garage/garage10.jpg" alt="" /><div className="swiper-slide-shadow" style={{opacity: 1}} /></div>
    //             </div>
    //             <div className="swiper-button-prev card-prev swiper-button-disabled" tabIndex={0} role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-adca2d9e6bfab343" aria-disabled="true" />
    //             <div className="swiper-button-next card-next" tabIndex={0} role="button" aria-label="Next slide" aria-controls="swiper-wrapper-adca2d9e6bfab343" aria-disabled="false" />
    //             <span className="swiper-notification" aria-live="assertive" aria-atomic="true" /></div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
